import React, { useState } from 'react';
import { Plus, Edit2, Trash2 } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import DataTable from '../../components/common/DataTable';
import Modal from '../../components/common/Modal';
import { formatDate, generateId } from '../../utils/helpers';

function BookCatalog() {
  const { books, saveBook, updateBook, deleteBook } = useApp();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ isbn:'', title:'', author:'', publisher:'', category:'', totalCopies:'1', availableCopies:'1', shelfLocation:'', addedDate:new Date().toISOString().split('T')[0] });
  const [editing, setEditing] = useState(null);

  const openAdd = () => { setForm({ isbn:'', title:'', author:'', publisher:'', category:'', totalCopies:'1', availableCopies:'1', shelfLocation:'', addedDate:new Date().toISOString().split('T')[0] }); setEditing(null); setModal(true); };
  const openEdit = (b) => { setForm(b); setEditing(b); setModal(true); };
  const remove = async (id) => { if(window.confirm('Delete book?')) await deleteBook(id); };
  const save = async () => {
    if(editing) await updateBook(editing.id, {...form,id:editing.id});
    else await saveBook({...form,id:generateId('BK')});
    setModal(false);
  };

  const columns = [
    { label: 'Title', key:'t', searchValue: b=>`${b.title||''} ${b.isbn||''}`, render: b=><div><p className="font-medium">{b.title}</p><p className="">ISBN: {b.isbn}</p></div> },
    { label: 'Author', accessor:'author', sortable:true },
    { label: 'Category', accessor:'category', sortable:true },
    { label: 'Publisher', accessor:'publisher' },
    { label: 'Shelf', accessor:'shelfLocation' },
    { label: 'Available', key:'avail', render: b=><div className="text-center"><span className={`font-semibold ${b.availableCopies>0?'text-green-600':'text-red-500'}`}>{b.availableCopies}</span><span className="text-gray-400">/{b.totalCopies}</span></div> },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold">Book Catalog</h1><p className="text-gray-500 text-sm">{books.length} books</p></div>
        <button onClick={openAdd} className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white px-4 py-1 rounded-lg text-sm font-medium"><Plus size={16}/>Add Book</button>
      </div>
      <DataTable columns={columns} data={books}
        actions={row=><>
          <button onClick={()=>openEdit(row)} className="p-1.5 hover:bg-purple-50 rounded-lg text-purple-600"><Edit2 size={15}/></button>
          <button onClick={()=>remove(row.id)} className="p-1.5 hover:bg-red-50 rounded-lg text-red-500"><Trash2 size={15}/></button>
        </>}
      />
      <Modal isOpen={modal} onClose={()=>setModal(false)} title={editing?'Edit Book':'Add Book'} size="lg">
        <div className="grid grid-cols-2 gap-3">
          {[['Title','title','text'],['Author','author','text'],['ISBN','isbn','text'],['Publisher','publisher','text'],['Category','category','text'],['Shelf Location','shelfLocation','text'],['Total Copies','totalCopies','number'],['Available Copies','availableCopies','number']].map(([label,key,type])=>(
            <div key={key}>
              <label className="block text-sm font-medium mb-1">{label}</label>
              <input type={type} value={form[key]||''} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-300" />
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-2 mt-4 pt-4 border-t">
          <button onClick={()=>setModal(false)} className="px-4 py-1 text-sm hover:bg-gray-100 rounded-lg">Cancel</button>
          <button onClick={save} className="px-4 py-1 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700">Save</button>
        </div>
      </Modal>
    </div>
  );
}
export default BookCatalog;
